export const HEADER_HEIGHT_VARIABLE = '--hw-header-height';
export const BOTTOM_NAV_HEIGHT_VARIABLE = '--hw-bottom-nav-height';

export const PROVIDER_PRICE_AND_AVAILABILITY_COMPONENT_PADDING_VARIABLE =
  '--hw-provider-price-and-availability-component-padding';
export const PROVIDER_HEADER_CARD_MARGIN_BOTTOM_VARIABLE =
  '--hw-provider-header-card-margin-bottom';
